import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { setLang, toggleLangDropdown } from '../redux/actions/main';


const StyledLangToggler = styled.div`
select{
  display: none;
    @media all and (max-width: 500px){
    /* display: block;    */
    }
}
`;
const Dropdown = styled.div`
position: relative;
  @media all and (max-width: 500px){
    /* display: none;    */
  }
  button{
    border: none;
    padding: 0;
    cursor: pointer;
    font-weight: bold;
    font-size: 12px;
    position: relative;
    &:after{
      content: ' ';
      position: absolute;
      right: -15px;
      top: 4px;
      width: 0; 
      height: 0; 
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-top: 7px solid #000;
    }
    &.open{
      &:after{
        transform: rotate(180deg);
      }
    }
  }
}
`;

const Languages = styled.ul`
  position: absolute;
  right: -15px;
  top: 15px;
  list-style-type: none;
  padding: 0;
  z-index: 3;
  background: #fff;
  width: 100px;
}
`;
const Language = styled.li`
cursor: pointer;
font-weight: bold;
padding: 2px 10px;
border: 1px solid #d7d8d8;
transition: ease all 0.2s;
&:nth-child(2) {
  border-bottom: 1px solid transparent;
  border-top: 1px solid transparent;
}
&:hover{
  border: 1px solid #56b4ef;
  box-shadow: 0 0 5px 0px rgba(86, 180, 239, 0.3);
}
}
`;

const LangToggler = ({
  setLanguage, lang, langDropdownOpen, toggleLanguageDropdown, copy,
}) => (
  <StyledLangToggler>
    <select
      name="lang"
      id="lang"
      value={lang}
      onChange={event => setLanguage(event.target.value)}
    >
      <option value="en">en</option>
      <option value="es">es</option>
      <option value="pt">pt</option>
    </select>
    <Dropdown>
      <button className={langDropdownOpen ? 'open' : ''} type="button" onClick={() => toggleLanguageDropdown(!langDropdownOpen)}>{copy.nav.lang}</button>
      {langDropdownOpen && (
        <Languages>
          <Language onClick={() => {
            toggleLanguageDropdown(!langDropdownOpen);
            setLanguage('en');
            window.dataLayer.push({
              category: 'Email_Submit',
              event: 'Click_Languaje',
              label: 'ENG',
            });
          }}
          >
            {copy.nav.en}

          </Language>
          <Language onClick={() => {
            toggleLanguageDropdown(!langDropdownOpen);
            setLanguage('es');
            window.dataLayer.push({
              category: 'Email_Submit',
              event: 'Click_Languaje',
              label: 'SPA',
            });
          }}
          >
            {copy.nav.es}

          </Language>
          <Language onClick={() => {
            toggleLanguageDropdown(!langDropdownOpen);
            setLanguage('pt');
            window.dataLayer.push({
              category: 'Email_Submit',
              event: 'Click_Languaje',
              label: 'POR',
            });
          }}
          >
            {copy.nav.pt}

          </Language>
        </Languages>
      )}
    </Dropdown>
  </StyledLangToggler>
);

LangToggler.defaultProps = {
};
LangToggler.propTypes = {
  copy: PropTypes.objectOf(PropTypes.object).isRequired,
  lang: PropTypes.string.isRequired,
  setLanguage: PropTypes.func.isRequired,
  langDropdownOpen: PropTypes.bool.isRequired,
  toggleLanguageDropdown: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch => ({
  setLanguage: lang => dispatch(setLang(lang)),
  toggleLanguageDropdown: bool => dispatch(toggleLangDropdown(bool)),
});

const mapStateToProps = state => ({
  ...state.main,
});

export default connect(mapStateToProps, mapDispatchToProps)(LangToggler);
